/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayCycle } from './PayCycle';
import {
    PayCycleFromJSON,
    PayCycleFromJSONTyped,
    PayCycleToJSON,
    PayCycleToJSONTyped,
} from './PayCycle';

/**
 * 
 * @export
 * @interface ShowPayCycleResponse
 */
export interface ShowPayCycleResponse {
    /**
     * 
     * @type {PayCycle}
     * @memberof ShowPayCycleResponse
     */
    data: PayCycle;
}

/**
 * Check if a given object implements the ShowPayCycleResponse interface.
 */
export function instanceOfShowPayCycleResponse(value: object): value is ShowPayCycleResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowPayCycleResponseFromJSON(json: any): ShowPayCycleResponse {
    return ShowPayCycleResponseFromJSONTyped(json, false);
}

export function ShowPayCycleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowPayCycleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PayCycleFromJSON(json['data']),
    };
}

  export function ShowPayCycleResponseToJSON(json: any): ShowPayCycleResponse {
      return ShowPayCycleResponseToJSONTyped(json, false);
  }

  export function ShowPayCycleResponseToJSONTyped(value?: ShowPayCycleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PayCycleToJSON(value['data']),
    };
}

